import { useMemo } from "react";
import { Navigate } from "react-router-dom";
import {
  apiRoleToAccountType,
  getAuthUser,
  getStoredAccountType,
  type AccountType,
} from "../auth";
import { companyBillingDetailPath } from "../lib/companyBillingPaths";
import { EnterpriseInvoiceDetailPage } from "./EnterpriseInvoiceDetailPage";

type InvoiceDetailPageRouterProps = {
  displayId: number;
};

function resolveAccountType(): AccountType | null {
  const stored = getStoredAccountType();
  if (stored) return stored;
  const user = getAuthUser();
  if (user?.role) return apiRoleToAccountType(user.role);
  return null;
}

function accountTypeToInvoiceScope(
  accountType: AccountType | null,
): "company" | "hospital" | "auditor" | "admin" {
  if (accountType === "hospital") return "hospital";
  if (accountType === "auditor") return "auditor";
  if (accountType === "admin") return "admin";
  return "company";
}

/** Détail facture prestataire (admin / auditeur / hôpital). Entreprise → redirect relevé. */
export function InvoiceDetailPageRouter({ displayId }: InvoiceDetailPageRouterProps) {
  const scope = useMemo(() => accountTypeToInvoiceScope(resolveAccountType()), []);

  if (scope === "company") {
    return <Navigate to={companyBillingDetailPath(displayId)} replace />;
  }

  return <EnterpriseInvoiceDetailPage displayId={displayId} scope={scope} />;
}

/** Détail relevé company_billing (compte entreprise uniquement). */
export function CompanyBillingDetailPageRouter({ displayId }: InvoiceDetailPageRouterProps) {
  const accountType = useMemo(() => resolveAccountType(), []);

  if (accountType && accountType !== "enterprise") {
    return <Navigate to={`/dashboard/invoices/${displayId}`} replace />;
  }

  return <EnterpriseInvoiceDetailPage displayId={displayId} scope="company" />;
}
